import axios from '@/libs/api.request'
import config from '@/config'

const workFlowBaseUrl = config.baseWorkflowUrl + '/api/v1/'

export const operateReleaseFlowEnclosureBaseUrl = workFlowBaseUrl + 'data/test_report_enclosure/'
export const operateReleaseFlowUploadEnclosureUrl = workFlowBaseUrl + 'operate_release_flow/upload_enclosure/'

export const getOperateReleaseFlow = (params) => {
  return axios.request({
    url: workFlowBaseUrl + 'operate_release_flow/',
    params: params,
    traditional: true,
    method: 'get'
  })
}

export const createOperateReleaseFlow = (data) => {
  return axios.request({
    url: workFlowBaseUrl + 'operate_release_flow/',
    data: data,
    method: 'post'
  })
}

export const detailOperateReleaseFlow = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'operate_release_flow/' + id + '/',
    method: 'get'
  })
}

export const deleteOperateReleaseFlow = (id) => {
  return axios.request({
    url: workFlowBaseUrl + 'operate_release_flow/' + id + '/',
    method: 'delete'
  })
}

export const submitOperateReleaseFlowTestReport = (id, content) => {
  return axios.request({
    url: workFlowBaseUrl + 'operate_release_flow/' + id + '/submit_test_report/',
    data: { content: content },
    method: 'put'
  })
}

export const getOpsTypeReleaseSteps = (data) => {
  return axios.request({
    url: workFlowBaseUrl + 'get_ops_type_release_steps/',
    data: data,
    method: 'post'
  })
}
